const stepsList = [
  {
    title: 'Запишитесь на консультацию',
    text: 'Познакомьтесь со своим персональным менеджером',
  },
  {
    title: 'Выберите свой тариф',
    text: 'Подберем наилучший тариф для вашего проекта',
  },
  {
    title: 'Отправьте первого курьера',
    text: 'Выберите первого клиента для встречи с курьером Dalli',
  },
];

export default {
  textTitle: 'Просто расскажите о вашей задаче',
  textText: 'Персональный менеджер подберет оптимальное решение',
  textButton: 'ZOOM с менеджером',
  textButtonSend: 'Отправить заявку',
  stepsList
}
